import type { RouteRecordRaw } from 'vue-router'
import AppointmentEmbed from '@/modules/CRM/appointment/components/AppointmentEmbed.vue'

export const crmRoutes: RouteRecordRaw[] = [
  {
    path: 'crm',
    component: () => import('@/modules/CRM/layout/CRMLayout.vue'),
    meta: { title: 'CRM', requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'MOPCRMDashboard' }
      },
      {
        path: 'dashboard',
        name: 'MOPCRMDashboard',
        component: () => import('@/modules/CRM/dashboard/components/CRMDashboard.vue'),
        meta: { title: 'CRM Dashboard', requiresAuth: true, breadcrumb: 'CRM Dashboard' }
      },
      {
        path: 'contacts',
        name: 'MOPCRMContacts',
        component: () => import('@/modules/CRM/contacts/components/ContactList.vue'),
        meta: { title: 'CRM Contacts', requiresAuth: true, breadcrumb: 'Contacts' }
      },
      {
        path: 'contacts/create',
        name: 'MOPCRMContactCreate',
        component: () => import('@/modules/CRM/contacts/components/ContactForm.vue'),
        meta: { title: 'Create Contact', requiresAuth: true, breadcrumb: 'Create Contact' }
      },
      {
        path: 'contacts/:id/edit',
        name: 'MOPCRMContactEdit',
        component: () => import('@/modules/CRM/contacts/components/ContactForm.vue'),
        meta: { title: 'Edit Contact', requiresAuth: true, breadcrumb: 'Edit Contact' }
      },
      {
        path: 'contacts/:id',
        name: 'MOPCRMContactDetail',
        component: () => import('@/modules/CRM/contacts/components/ContactDetail.vue'),
        meta: { title: 'Contact Detail', requiresAuth: true }
      },
      // Leads
      {
        path: 'leads',
        name: 'MOPCRMLeads',
        component: () => import('@/modules/CRM/leads/components/LeadList.vue'),
        meta: { title: 'CRM Leads', requiresAuth: true, breadcrumb: 'Leads' }
      },
      {
        path: 'leads/create',
        name: 'MOPCRMLeadCreate',
        component: () => import('@/modules/CRM/leads/components/LeadForm.vue'),
        meta: { title: 'Create Lead', requiresAuth: true, breadcrumb: 'Create Lead' }
      },
      {
        path: 'leads/:id/edit',
        name: 'MOPCRMLeadEdit',
        component: () => import('@/modules/CRM/leads/components/LeadForm.vue'),
        meta: { title: 'Edit Lead', requiresAuth: true, breadcrumb: 'Edit Lead' }
      },
      {
        path: 'leads/:id',
        name: 'MOPCRMLeadDetail',
        component: () => import('@/modules/CRM/leads/components/LeadDetail.vue'),
        meta: { title: 'Lead Detail', requiresAuth: true }
      },
      // Appointment (embedded external booking app — opened from contact/lead three-dot menu)
      {
        path: 'appointment',
        name: 'MOPCRMAppointment',
        component: AppointmentEmbed,
        meta: { title: 'Book Appointment', requiresAuth: true, breadcrumb: 'Book Appointment' }
      },
      // Tasks
      {
        path: 'tasks',
        name: 'MOPCRMTasks',
        component: () => import('@/modules/CRM/tasks/components/TaskList.vue'),
        meta: { title: 'CRM Tasks', requiresAuth: true, breadcrumb: 'Tasks' }
      },
      {
        path: 'tasks/create',
        name: 'MOPCRMTaskCreate',
        component: () => import('@/modules/CRM/tasks/components/TaskForm.vue'),
        meta: { title: 'Create Task', requiresAuth: true, breadcrumb: 'Create Task' }
      },
      {
        path: 'tasks/:id/edit',
        name: 'MOPCRMTaskEdit',
        component: () => import('@/modules/CRM/tasks/components/TaskForm.vue'),
        meta: { title: 'Edit Task', requiresAuth: true, breadcrumb: 'Edit Task' }
      },
      // Call Logs
      {
        path: 'call-logs',
        name: 'MOPCRMCallLogs',
        component: () => import('@/modules/CRM/callLogs/components/CallLogList.vue'),
        meta: { title: 'CRM Call Logs', requiresAuth: true, breadcrumb: 'Call Logs' }
      },
      // Campaigns
      { path: 'campaigns', name: 'MOPCRMCampaigns', component: () => import('@/modules/CRM/campaigns/components/CampaignList.vue'), meta: { title: 'Campaigns', requiresAuth: true } },
      { path: 'campaigns/create', name: 'MOPCRMCampaignCreate', component: () => import('@/modules/CRM/campaigns/components/CampaignForm.vue'), meta: { title: 'Create Campaign', requiresAuth: true } },
      { path: 'campaigns/:id/edit', name: 'MOPCRMCampaignEdit', component: () => import('@/modules/CRM/campaigns/components/CampaignForm.vue'), meta: { title: 'Edit Campaign', requiresAuth: true } },
      // WhatsApp
      { path: 'whatsapp', name: 'MOPCRMWhatsApp', component: () => import('@/modules/CRM/whatsapp/components/WhatsAppPage.vue'), meta: { title: 'WhatsApp', requiresAuth: true } },
      // Settings
      { path: 'settings', name: 'MOPCRMSettings', component: () => import('@/modules/CRM/settings/components/CRMSettings.vue'), meta: { title: 'Settings', requiresAuth: true } },
      // Masters
      { path: 'masters', name: 'MOPCRMMasters', component: () => import('@/modules/CRM/masters/components/MastersHome.vue'), meta: { title: 'Masters', requiresAuth: true } },
      { path: 'masters/lead-status', name: 'MOPCRMLeadStatus', component: () => import('@/modules/CRM/masters/leadStatus/components/LeadStatusList.vue'), meta: { title: 'Lead Status', requiresAuth: true } },
      { path: 'masters/lead-source', name: 'MOPCRMLeadSource', component: () => import('@/modules/CRM/masters/leadSource/components/LeadSourceList.vue'), meta: { title: 'Lead Source', requiresAuth: true } },
      { path: 'masters/contact-type', name: 'MOPCRMContactType', component: () => import('@/modules/CRM/masters/contactType/components/ContactTypeList.vue'), meta: { title: 'Contact Type', requiresAuth: true } },
      { path: 'masters/agents', name: 'MOPCRMAgentMaster', component: () => import('@/modules/CRM/masters/agentMaster/components/AgentMasterList.vue'), meta: { title: 'Agent Master', requiresAuth: true } },
      { path: 'masters/task-status', name: 'MOPCRMTaskStatus', component: () => import('@/modules/CRM/masters/taskStatus/components/TaskStatusList.vue'), meta: { title: 'Task Status', requiresAuth: true } },
      { path: 'masters/task-type', name: 'MOPCRMTaskType', component: () => import('@/modules/CRM/masters/taskType/components/TaskTypeList.vue'), meta: { title: 'Task Type', requiresAuth: true } },
      { path: 'masters/projects', name: 'MOPCRMProjectMaster', component: () => import('@/modules/CRM/masters/projectMaster/components/ProjectMasterList.vue'), meta: { title: 'Project Master', requiresAuth: true } },
      { path: 'masters/code-template', name: 'MOPCRMCodeTemplate', component: () => import('@/modules/CRM/masters/codeTemplate/components/CodeTemplateList.vue'), meta: { title: 'Code Template', requiresAuth: true } },
      // Reports
      { path: 'reports', name: 'MOPCRMReports', component: () => import('@/modules/CRM/reports/components/ReportsPage.vue'), meta: { title: 'Reports', requiresAuth: true } }
    ]
  }
]
